import { LitElement, html, css, unsafeCSS } from 'lit';
import styles from './select-radio-option.scss?inline';

export default class SotbitSelectRadioOption extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        value: { type: String, reflect: true },
        disabled: { type: Boolean, reflect: true },
        selected: { type: Boolean, reflect: true },
        label: { type: String },
    };

    constructor() {
        super();
        this.value = '';
        this.disabled = false;
        this.selected = false;
    }

    render() {
        return html`
            <div class="option" part="option">
                <div class="option__radio-box" part="option-radio-box">
                    <sotbit-radio-option
                        part="option-radio"
                        .checked=${this.selected}
                        ?checked=${this.selected}
                        ?disabled=${this.disabled}
                        tabindex="-1"
                    ></sotbit-radio-option>
                </div>
                <div part="caption">
                    <slot></slot>
                </div>
            </div>
        `;
    }
}
